import React, {Component} from 'react';
import {Row, Col, Button, Modal} from 'react-bootstrap';

class PatientRefundStatusChange extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  submit = () => {
    let value = this.props.PatientPaymentrefundDtls;
    this.props.PatientRefundStatusChange(value);
    this.props.handleClose();
    //   this.props.resetPage();
  };

  render() {
    const datas =
      this.props.PatientPaymentrefundDtls &&
      this.props.PatientPaymentrefundDtls.data
        ? this.props.PatientPaymentrefundDtls &&
          this.props.PatientPaymentrefundDtls.data
        : null;
    console.log('############################', datas);

    return (
      <div>
        <div className="userModalDiv">
          <Modal
            show={this.props.show}
            onHide={this.props.handleClose}
            animation={false}
            size="md"
            backdrop="static"
            centered={true}
          >
            <Modal.Body>
              <div>
                <h6 style={{textAlign: 'center', marginTop: '20px'}}>
                  <b>Are you sure you want to Refund?</b>
                </h6>
              </div>
              <Row style={{marginTop: '30px', marginBottom: '30px'}}>
                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                  <Button
                    variant="danger"
                    className="cmnDelCnclBtn"
                    onClick={() => this.props.handleClose()}
                  >
                    CANCEL
                  </Button>
                </Col>
                <Col xs={6} sm={6} md={6} lg={6} xl={6}>
                  <Button
                    variant="success"
                    className="cmnDelOkBtn"
                    onClick={this.submit}
                  >
                    OK
                  </Button>
                </Col>
              </Row>
            </Modal.Body>
          </Modal>
        </div>
      </div>
    );
  }
}

export default PatientRefundStatusChange;
